module.exports = __webpack_public_path__ + "img/xpzz.ba2cd2f7.png";